import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import {
  GenericMutationResponseType,
  GenericMutationResponse
} from '../types/generic-mutation-response'
import { Context } from '../shared'
import {
  routeDeleteMutationArgs,
  RouteDeleteMutationArgs
} from '../types/route-delete-mutation-args'
import { Connector } from '../../../api/connector'

function deleteRouteRequest(
  connector: Connector,
  organizationUuid: string,
  applicationUuid: string,
  routeHashes: string[]
) {
  return connector.executeDelete(
    `/${organizationUuid}/applications/${applicationUuid}/route/bulk`,
    {
      routeHashes
    }
  )
}

export const deleteRoute: GraphQLFieldConfig<
  any,
  Context,
  RouteDeleteMutationArgs
> = {
  description: 'Delete a route',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: routeDeleteMutationArgs,
  resolve: async (
    _source,
    args,
    context: Context
  ): Promise<GenericMutationResponse> => {
    const { input } = args

    if (!input) {
      throw new Error('mutation input parameter is required')
    }

    const { organizationUuid, applicationUuid, routeHash } = input

    const { connector } = context

    await deleteRouteRequest(connector, organizationUuid, applicationUuid, [
      routeHash
    ])

    return { _placeholder: true }
  }
}
